export const en = {
    placeholder: 'Enter a negative keyword'
};
